export function createCategoryPathSegmentFromCategoryTitle(categoryTitle) {
  const raw = String(categoryTitle || '').trim().toLowerCase();
  if (!raw) return '';
  if (raw === 'commercials') return 'commercial';
  if (raw === 'music videos') return 'music-videos';
  if (raw === 'fiction') return 'fiction';
  return raw
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function buildChannelPath(channel) {
  const categoryPathSegment = createCategoryPathSegmentFromCategoryTitle(channel && channel.categoryTitle);
  const categoryPrefix = categoryPathSegment ? `${encodeURIComponent(categoryPathSegment)}/` : '';
  return `${categoryPrefix}${encodeURIComponent(channel.slug)}/`;
}

export function buildChannelPathForIndex(channels, channelIndex) {
  const index = Number(channelIndex);
  if (!Number.isFinite(index) || index < 0 || index >= channels.length) return '';

  const channel = channels[index] || {};
  const categoryPathSegment = createCategoryPathSegmentFromCategoryTitle(channel.categoryTitle);
  const categoryPrefix = categoryPathSegment ? `/${encodeURIComponent(categoryPathSegment)}` : '';
  return `${categoryPrefix}/${encodeURIComponent(channel.slug || String(index + 1))}/`;
}

export function parseChannelRouteFromPathname(pathname) {
  const normalized = String(pathname || '').replace(/\/+$/, '') || '/';
  if (normalized === '/') return null;

  const legacyWithCategory = normalized.match(/^\/([^/]+)\/channel\/([^/]+)$/i);
  if (legacyWithCategory) {
    return {
      categoryPathSegment: decodeURIComponent(legacyWithCategory[1]).trim(),
      slug: decodeURIComponent(legacyWithCategory[2]).trim(),
      isLegacyChannelPath: true
    };
  }

  const legacyRoot = normalized.match(/^\/channel\/([^/]+)$/i);
  if (legacyRoot) {
    return {
      categoryPathSegment: '',
      slug: decodeURIComponent(legacyRoot[1]).trim(),
      isLegacyChannelPath: true
    };
  }

  const withCategory = normalized.match(/^\/([^/]+)\/([^/]+)$/i);
  if (withCategory) {
    return {
      categoryPathSegment: decodeURIComponent(withCategory[1]).trim(),
      slug: decodeURIComponent(withCategory[2]).trim(),
      isLegacyChannelPath: false
    };
  }

  return null;
}
